export enum QueryTags {
  SERVER_RULES = 'serverRules',
  INVITE_PEOPLE = 'invitePeople',
  LIKES = 'likes',
  COMMENTS = 'comments',
  REPOSTS = 'reposts',
}

// TODO -> move all query tags to this enum
